import { useState } from 'react';
import { ContactAdvisorButton } from '@/components/ContactAdvisorButton';
import { RequestAdvisorMeetingModal } from '@/components/RequestAdvisorMeetingModal';
import { TopBannerOnboarding } from '@/components/TopBannerOnboarding';
import { Lock } from 'lucide-react';

export function OnboardingResultsPending() {
  const [isRequestMeetingOpen, setIsRequestMeetingOpen] = useState(false);

  return (
    <>
      <div id="top-container">
        <div className="flex min-h-[800px] flex-col px-2 pb-[140px] pt-4 md:px-20">
          <TopBannerOnboarding className="px-2 pb-5 md:px-0" />

          <div className="mx-auto w-full max-w-2xl">
            <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm md:p-10">
              <div className="flex flex-col items-center gap-5 text-center">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100">
                  <Lock className="text-primary h-7 w-7" />
                </div>

                <div className="space-y-2">
                  <h2 className="text-2xl font-bold text-gray-900 md:text-3xl">
                    We&apos;re currently finalizing your long-term care plan behind the scenes.
                  </h2>
                  <p className="text-base text-gray-700 md:text-lg">
                    Once everything is ready, your advisor will share the results with you.
                  </p>
                  <p className="text-base text-gray-700 md:text-lg">
                    In the meantime, you&apos;re welcome to connect with your advisor to review
                    details together or request an update.
                  </p>
                </div>

                <div className="flex flex-col gap-3 sm:flex-row">
                  <ContactAdvisorButton
                    className="w-full sm:w-auto"
                    requestMeetingOnClick={() => setIsRequestMeetingOpen(true)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RequestAdvisorMeetingModal
        open={isRequestMeetingOpen}
        onClose={() => setIsRequestMeetingOpen(false)}
      />
    </>
  );
}
